export const BLOG_IMAGE_WIDTH = 750;
export const BLOG_IMAGE_HEIGHT = 430;

export const PMG_IMAGE_WIDTH = 758;
export const PMG_IMAGE_HEIGHT = 379;
